import { withStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";

export const CustomTextField = withStyles((theme) => ({
  root: {
    height: theme.spacing(4),
    minWidth: 300,
    "& .MuiOutlinedInput-root": {
      height: theme.spacing(4),
      padding: "0 8px !important",
      borderRadius: theme.spacing(2),
      "& fieldset": {
        borderColor: "#c4c4c4",
      },
      "&:hover fieldset": {
        borderColor: "#c4c4c4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#c4c4c4",
        borderWidth: 1,
      },
    },
    "& .iconButton": {
      marginRight: -theme.spacing(1),

      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  },
}))(TextField);
